import React from "react";
import { Route, Routes } from "react-router-dom";
import { History } from "history";
import { ConnectedProps, connect } from "react-redux";
import collectionRoutes from "us.collection/routes";
import Common from "us.common";
import { RootState } from "us.helper/types";
import { DndProvider } from "react-dnd";
import { HTML5Backend } from "react-dnd-html5-backend";
import { AuthGate } from "us.common/auth";

const { Page404, AppLayout, ConfigProvider } = Common.Components;
type AppProps = {
  history: History;
};

const App: React.FC<AppProps & PropsFromRedux> = ({
  history,
  caseNo,
  currentLanguage,
}) => {
  return (
    <AuthGate>
      <AppLayout>
        <ConfigProvider locale={currentLanguage}>
          <DndProvider backend={HTML5Backend}>
            <Routes>
              {collectionRoutes(caseNo)}
              <Route path="*" element={<Page404 />} />
            </Routes>
          </DndProvider>
        </ConfigProvider>
      </AppLayout>
    </AuthGate>
  );
};

const mapStateToProps = (state: RootState) => {
  return {
    caseNo: state.case.caseNo,
    currentLanguage: state.common.currentLanguage,
  };
};

const mapDispatchToProps = {};

const connector = connect(mapStateToProps, mapDispatchToProps);

type PropsFromRedux = ConnectedProps<typeof connector>;

export default connector(App);
